(() => {
  const cleanExample = (value) => value.replace(/^Örn\.\s*/i, '').trim();

  const encodeRecipe = (payload) => {
    const bytes = new TextEncoder().encode(JSON.stringify(payload));
    let binary = '';
    bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
    return `v1.${btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')}`;
  };

  const ensurePropertyInput = (form, propertyName) => {
    const inputName = `properties[${propertyName}]`;
    let input = Array.from(form.elements).find((field) => field.name === inputName && field.type === 'hidden');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      form.appendChild(input);
    }
    return input;
  };

  const syncMapDesignLinks = (personalizer, submittedForm = null) => {
    const form = submittedForm
      || personalizer?.closest('product-form')?.querySelector('form')
      || personalizer?.closest('form');
    if (!form) return;

    const recipeFields = {
      '_Enlem': 'la',
      '_Boylam': 'lo',
      '_Harita Zoom': 'z',
      '_Harita Sahnesi': 'ms',
      '_Kalp X': 'hx',
      '_Kalp Y': 'hy',
      '_Kalp Enlem': 'hla',
      '_Kalp Boylam': 'hlo',
      '_Harita Şekli': 'sh',
      '_Harita Stili': 'st',
      '_Başlık Fontu': 'tf',
      '_İsim Fontu': 'nf',
    };
    const recipe = { m: 'mac-pdf-v1' };
    Object.entries(recipeFields).forEach(([propertyName, shortName]) => {
      const inputName = `properties[${propertyName}]`;
      const field = Array.from(form.elements).find((element) => element.name === inputName);
      const value = String(field?.value || '').trim();
      if (value) recipe[shortName] = value;
    });

    const previewInput = ensurePropertyInput(form, 'Tasarım Önizleme');
    const designInput = ensurePropertyInput(form, 'Tasarım Dosyası');
    const existingMatch = String(designInput.value || '').match(/\/order-designs\/([a-f0-9-]{36})\/design\.pdf/i)
      || String(previewInput.value || '').match(/\/order-designs\/([a-f0-9-]{36})\/preview\.pdf/i);
    const token = existingMatch?.[1] || form.dataset.renaoMapDesignToken || (window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
        const random = Math.floor(Math.random() * 16);
        return (character === 'x' ? random : (random & 0x3) | 0x8).toString(16);
      }));
    form.dataset.renaoMapDesignToken = token;
    const baseUrl = `https://renao-design-files.renaogift.workers.dev/order-designs/${token}`;
    previewInput.value = `${baseUrl}/preview.pdf`;
    designInput.value = `${baseUrl}/design.pdf#r=${encodeRecipe(recipe)}`;
  };

  const syncPreview = (personalizer) => {
    if (personalizer.querySelector('[data-renao-map-modal]')) return;

    const nameInput = personalizer.querySelector('[data-renao-preview-input]');
    const dateInput = personalizer.querySelector('[data-renao-preview-date]');
    const titleInput = personalizer.querySelector('[data-renao-preview-title-input]');
    const cityInput = personalizer.querySelector('[data-renao-preview-city-input]');
    const coordsInput = personalizer.querySelector('[data-renao-preview-coords-input]');
    const stage = personalizer.querySelector('[data-renao-preview-stage]');
    if (!stage || !nameInput) return;

    const name = nameInput.value.trim();
    const date = dateInput ? dateInput.value.trim() : '';
    const title = titleInput ? titleInput.value.trim() : '';
    const city = cityInput ? cityInput.value.trim() : '';
    const coords = coordsInput ? coordsInput.value.trim() : '';
    const previewName = stage.querySelector('[data-renao-preview-name]');
    const previewDate = stage.querySelector('[data-renao-preview-date-output]');
    const previewTitle = stage.querySelector('[data-renao-preview-title]');
    const previewCity = stage.querySelector('[data-renao-preview-city]');
    const previewCoords = stage.querySelector('[data-renao-preview-coords]');

    previewName.textContent = cleanExample(name || nameInput.placeholder || 'Nurdan & Batuhan');
    if (previewDate) previewDate.textContent = cleanExample(date || dateInput.placeholder || '27/10/2025');
    if (previewTitle) previewTitle.textContent = cleanExample(title || titleInput.placeholder || 'HİKAYEMİZİN BAŞLADIĞI YER');
    if (previewCity) previewCity.textContent = cleanExample(city || cityInput.placeholder || 'Edirne');
    if (previewCoords) previewCoords.textContent = cleanExample(coords || coordsInput.placeholder || `41°40'20.44"N, 26°33'45.61"E`);
    stage.classList.toggle('is-empty', !name && !date && !title && !city && !coords);
  };

  const boot = () => {
    document.querySelectorAll('[data-renao-personalizer]').forEach((personalizer) => {
      syncPreview(personalizer);
    });
  };

  const handleFieldUpdate = (event) => {
    const field = event.target.closest('[data-renao-preview-input], [data-renao-preview-date], [data-renao-preview-title-input], [data-renao-preview-city-input], [data-renao-preview-coords-input]');
    if (!field) return;

    const personalizer = field.closest('[data-renao-personalizer]');
    if (personalizer) syncPreview(personalizer);
  };

  document.addEventListener('input', handleFieldUpdate);
  document.addEventListener('change', handleFieldUpdate);
  // Capture runs before the product form's submit handler, so even an
  // immediate tap serializes the exact map recipe and both public links.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const personalizer = form.closest('product-form')?.querySelector('[data-renao-personalizer]');
    const hasMapFields = Array.from(form.elements).some((field) => (
      field.name === 'properties[Harita Adresi]'
      || field.name === 'properties[_Enlem]'
      || field.name === 'properties[_Boylam]'
    ));
    if (personalizer || hasMapFields) syncMapDesignLinks(personalizer, form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
